import _extends from '@babel/runtime/helpers/extends';
import React__default, { useRef, useCallback } from 'react';
import styled from 'styled-components';
import { M as MenuItem, B as BaseMenuItemMixin } from './MenuItem.styles-3gyHsVok.js';
import { K as KEYBOARD_KEYNAMES } from '../../LocalModules/storm-ui-utils/dist/esm/keyboardKeynames-CVa_vjg3-CVa_vjg3.js';
import { a as TaktIdConsumer } from '../../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { c as createStormTaktId } from '../../TaktIdContext/TaktIdContext.utils-B0CzqlN8.js';
import { L as LinkButton } from '../../Button/LinkButton/LinkButton-Bw4cFEhB.js';

const StyledLinkButton = /*#__PURE__*/styled(LinkButton).withConfig({
  componentId: "sc-storm-ui-40025937__sc-bhplnc-0"
})(["", ""], BaseMenuItemMixin);
const MenuItemLink = ({
  children,
  disabled = false,
  href,
  rel = 'noopener noreferrer',
  target = '_blank',
  onClick,
  taktId,
  taktValue,
  ...rest
}) => {
  const linkRef = useRef(null);
  const onClickHandler = useCallback(event => {
    if (disabled) {
      event.preventDefault();
    } else {
      onClick === null || onClick === void 0 || onClick(event);
    }
    event.stopPropagation();
  }, [disabled, onClick]);
  const onKeyDown = useCallback(event => {
    const {
      key
    } = event;
    if (!disabled && (key === KEYBOARD_KEYNAMES.ENTER || key === KEYBOARD_KEYNAMES.SPACE)) {
      var _linkRef$current;
      (_linkRef$current = linkRef.current) === null || _linkRef$current === void 0 || _linkRef$current.click();
    }
  }, [disabled]);
  return /*#__PURE__*/React__default.createElement(TaktIdConsumer, {
    taktId: taktId,
    taktValue: taktValue,
    fallbackId: createStormTaktId('menu-item-button')
  }, ({
    getDataTaktAttributes
  }) => /*#__PURE__*/React__default.createElement(MenuItem, null, /*#__PURE__*/React__default.createElement(StyledLinkButton, _extends({
    variant: "transparent"
  }, getDataTaktAttributes(), rest, {
    href: disabled ? undefined : href,
    linkRef: linkRef,
    rel: rel,
    target: target,
    disabled: disabled,
    "aria-disabled": disabled,
    onClick: onClickHandler,
    onKeyDown: onKeyDown
  }), children)));
};

export { MenuItemLink as M };
//# sourceMappingURL=MenuItemLink-CanMPXHv.js.map
